import { render, staticRenderFns } from "./MainSportFilter.vue?vue&type=template&id=8d68f51e&scoped=true&"
import script from "./MainSportFilter.vue?vue&type=script&lang=js&"
export * from "./MainSportFilter.vue?vue&type=script&lang=js&"
import style0 from "./MainSportFilter.vue?vue&type=style&index=0&id=8d68f51e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d68f51e",
  null
  
)

export default component.exports